module.exports = __webpack_public_path__ + "img/banner-tc4.952cc957.jpg";